import { createContext, useContext, useMemo } from "react";
import {
  FileService,
  FileApi,
  FileDataService,
  FileDataApi,
} from "decodable-sdk-js/v1alpha2";
import { useAccountScopedFetch } from "../../../lib/api";
import { useDataPlaneClient } from "../../../hooks/useDataPlaneClient";

export const FileApiContext = createContext<FileApi>(null);

export function FilesApiProvider({
  children = null,
}: {
  children?: React.ReactNode;
}) {
  const fetch = useAccountScopedFetch();
  const service = useMemo(() => fetch && new FileService(fetch), [fetch]);

  return (
    <FileApiContext.Provider value={service}>
      <FileDataApiProvider>{children}</FileDataApiProvider>
    </FileApiContext.Provider>
  );
}

export function useFileApi(): FileApi | null {
  return useContext(FileApiContext);
}

export const FileDataApiContext = createContext<Promise<FileDataApi>>(null);

export function FileDataApiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const dataPlaneClient = useDataPlaneClient();
  const service = useMemo(
    async () => new FileDataService({ client: await dataPlaneClient }),
    [dataPlaneClient]
  );

  return (
    <FileDataApiContext.Provider value={service}>
      {children}
    </FileDataApiContext.Provider>
  );
}

export function useFileDataApi(): Promise<FileDataApi> {
  return useContext(FileDataApiContext);
}
